module.exports = __webpack_public_path__ + "static/media/news-2.b4ba04c3.jpg";